<template>
  <div id="app" style="use-select: none">
    <router-view />
  </div>
</template>
<script>
import { loadFont } from "@/utils/loadFont";
export default {
  name: "App",
  setup() {
    return {};
  },
  mounted() {
    console.log("app mounted");
    document.addEventListener("copy", (e) => {
      e.preventDefault();
    });

    // 禁止选择文本
    document.body.style.userSelect = "none";
  },
  async created() {
    // 读取配置文件
    // const response = await fetch('/config.json')
    // this.config = await response.json()
    // console.log(this.config,'config')
    // await loadFont(
    //   'kunpeng',
    //   'https://aixrb.oss-ap-northeast-1.aliyuncs.com/fonts/PINGFANG%20REGULAR.75225b29.TTF'
    // )
    // 修改名称
    // this.config.appName = '2222'
    // 如果需要保存回文件，需要后端支持
  },
  beforeDestroy() {
    // 移除事件监听器
    document.removeEventListener("copy", (e) => {
      e.preventDefault();
    });
    document.body.style.userSelect = "auto";
  },
};
window.onload = function () {
  document.body.style.overflow = "hidden";
  document.addEventListener("touchstart", function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener("gesturestart", function (event) {
    event.preventDefault();
  });
  // document.body.addEventListener('focusin', () => {
  //   clearTimeout(myFunction)
  // })
  document.body.addEventListener("focusout", () => {
    clearTimeout(myFunction);
    myFunction = setTimeout(function () {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, 200);
  });
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px !important;
  overflow: auto !important;
  background: #5c554c !important;
  -webkit-appearance: auto !important;
  display: block;
}
html,
body {
  height: 100%;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  font-family: "Source Han Serif SC";
  overflow: hidden;
  background: #000;
}

#app {
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: #000;
}
@font-face {
  font-family: "kunpeng";
  src: url("./assets/font/昆明海鸥体.woff2") format("woff2");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
/* src/assets/fonts.css */
@font-face {
  font-family: "songti"; /* 自定义字体名称 */
  src:url('./assets/font/SourceHanSerifCN-SemiBold.otf') format('truetype');
  /* src: url("./assets/font/sourcehanserifcn-semibold-webfont.woff2") format("woff2"); */
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Source Han Serif SC";
  src:url('./assets/font/SourceHanSerifCN-SemiBold.otf') format('truetype');
  /* src: url("./assets/font/sourcehanserifcn-semibold-webfont.woff2") format("woff2"); */
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Source Han Serif SC-Regular";
  src: url("./assets/font/PINGFANG REGULAR.woff2") format("woff2");
  /* src:url('./assets/font/PINGFANG REGULAR.TTF') format('truetype'); */
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
</style>
